import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Input } from 'reactstrap';
import { db } from '../../firebase/firebase';


class OnSiteFeedback extends Component {
  constructor(props){
    super(props);
    this.state = {
      showTextarea: true,
      showMSG: false,
      text: '',
      mail: ''
    };
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({[e.target.name]: e.target.value});
  }

  handleSubmit = () => {
    if(this.state.text !== ''){
      const newDate = new Date();
      var newFeedbackRef = db.ref('feedback').push();
      newFeedbackRef.set({
        user: this.state.mail,
        text: this.state.text,
        timestamp: newDate.toISOString(),
        parameter: {
          path: this.props.path,
          query: this.props.query,
          type: 'onsite-feedback'
        }
      });

      this.setState({
        showTextarea: false,
        text: '',
        showMSG: true
      });

    }
  }
  render() {
    const textarea_placeholder = this.props.textarea_placeholder || "Dein Feedback";
    const button_text = this.props.button_text || "Feedback senden";

    return (
      <React.Fragment>
        { this.state.showTextarea &&
          <React.Fragment>
            <Input type="textarea" name="text" className="border rounded pt-2 mb-2 d-block" style={{resize: 'none'}} value={ this.state.text } onChange={ this.handleChange } placeholder={ textarea_placeholder } />
            <Input type="email" name="mail" className="border mb-2 rounded" value={ this.state.email } onChange={ this.handleChange } placeholder="E-Mail für Rückfragen (optional)" bsSize="sm" />
            <Button color="primary" block onClick={ this.handleSubmit }><i className="fas fa-envelope mr-2"></i>{ button_text }</Button>
          </React.Fragment>
        }
        { this.state.showMSG &&
          <p className="mt-5 text-primary font-weight-bold">Danke für dein Feedback!</p>
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  path: props.location.pathname,
  query: state.query
});

export default withRouter(connect(mapStateToProps)(OnSiteFeedback));



// WEBPACK FOOTER //
// ./src/components/ui-elements/OnSiteFeedback.js